import React, { useState, useEffect, useRef } from 'react';
import {
  Form,
  Input,
  Button,
  Table,
  notification,
  Breadcrumb,
  Tag,
  Drawer,
  Spin,
  Popconfirm,
  Modal,
} from 'antd';
import {
  PlusCircleTwoTone,
  EditOutlined,
  ArrowLeftOutlined,
  DeleteOutlined,
  HomeOutlined,
  EyeOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import _ from 'lodash';
import API from '../../utils/Api';
import HTMLEditor from '../../utils/jodit-react-component';

const { Search } = Input;

const EmailTemplate = () => {
  const myApi = new API({});
  myApi.createEntity({ name: 'message-template' });
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [updateID, setKey] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [title, setTitle] = useState('');
  const [ModalVisible, setModalVisible] = useState(false);
  const [Modalvalue, setModalvalue] = useState('');
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [variableCount, setVariableCount] = useState(0);
  const joditEditor = useRef(null);

  const fetchData = () => {
    setLoading(true);
    const appId = Cookies.get('appID');
    const payLoad = { id: appId };
    const params = { params: { template_type: 'email' } };
    const apiArray = [myApi.endpoints.messageTemplate.getById(payLoad, params)];
    Promise.all(apiArray)
      .then((res) => {
        const templateData = res[0].data.templates;
        setTableData(templateData);
        setSearchData(templateData);
        setLoading(false);
      })
      .catch(() => notification.error({ message: 'Failed to load the data.' }));
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (variableCount) {
      joditEditor.current.component.selection.insertHTML(`<span>{{${variableCount}}}</span>`);
    }
  }, [variableCount]);

  const showDrawer = () => {
    setTitle('Create Email Template');
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
    setKey(null);
    form.resetFields();
  };
  const onFinish = (values) => {
    setLoadingBtn(true);
    if (updateID) {
      values.app_id = Cookies.get('appID');
      values.template_type = 'email';
      values.id = updateID;
      myApi.endpoints.messageTemplate.update(values)
        .then(() => {
          notification.success({ message: 'updated successfully.' });
          setLoadingBtn(false);
          setKey(null);
          setVisible(false);
          form.resetFields();
          fetchData();
        })
        .catch((err) => {
          setLoadingBtn(false);
          notification.error({
            message: _.get(err, 'response.data.message', 'Failed to update email template.'),
          });
        });
    } else {
      values.app_id = Cookies.get('appID');
      values.template_type = 'email';
      myApi.endpoints.messageTemplate
        .create(values)
        .then(() => {
          notification.success({ message: 'Created successfully.' });
          setLoadingBtn(false);
          setVisible(false);
          form.resetFields();
          fetchData();
        })
        .catch((err) => {
          setLoadingBtn(false);
          notification.error({
            message: _.get(err, 'response.data.message', 'Failed to create email template.'),
          });
        });
    }
  };

  const globalSearch = (e) => {
    let { value } = e.target;
    let filteredData = [];
    value = value.toString().toLowerCase();
    if (!value) {
      filteredData.push(...searchData);
    } else {
      filteredData = searchData.filter((res) => Object.keys(res).some(
        (resp) => res[resp] && res[resp].toString().toLowerCase().includes(value),
      ));
    }
    setTableData(filteredData);
  };

  const handleEdit = (data, values) => {
    setKey(values.id);
    setVisible(true);
    form.setFieldsValue(values.email_template);
    setTitle('Edit Email Template');
  };
  const handlePreview = (data, values) => {
    setModalVisible(true);
    setModalvalue(values.email_template.email_content);
  };

  const handleDelete = (e, key) => {
    const params = { params: { template_type: 'email' } };
    myApi.endpoints.messageTemplate.delete({ id: key.email_template.id }, params).then((res) => {
      if (res.data) {
        notification.success({ message: 'Deleted successfully' });
        fetchData();
      } else notification.error({ message: 'Failed to delete the API KEY' });
    });
  };

  useEffect(() => {
    if (variableCount) {
      const templateValue = form.getFieldValue('content');
      form.setFieldsValue({ content: `${templateValue}{{${variableCount}}}` });
    }
  }, [variableCount]);

  const handleAddVariable = () => {
    setVariableCount(variableCount + 1);
  };

  const refreshData = () => {
    fetchData();
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: ['email_template', 'template_name'],
    },
    {
      title: 'Message',
      align: 'left',
      render: (a) => (

        <Tag color="green" onClick={(e) => handlePreview(e, a)}>
          <EyeOutlined style={{ color: 'skyblue' }} />
        </Tag>

      ),
    },
    {
      title: 'Action',
      width: 100,
      align: 'right',
      render: (a) => (
        <span className="edit-box">
          <Tag color="green" onClick={(e) => handleEdit(e, a)}>
            <EditOutlined />
          </Tag>
          <Popconfirm
            placement="topRight"
            title="Are you sure to delete this Template"
            onConfirm={(e) => handleDelete(e, a)}
            okText="Yes"
            cancelText="No"
          >
            <Tag color="red">
              <DeleteOutlined />
            </Tag>
          </Popconfirm>
        </span>
      ),
    },
  ];

  return (
    <div>
      <Spin spinning={loading}>
        <div className="search-container">
          <Breadcrumb>
            <Breadcrumb.Item href="/channels"><HomeOutlined /></Breadcrumb.Item>
            <Breadcrumb.Item href="/channels">Channels</Breadcrumb.Item>
            <Breadcrumb.Item>Email</Breadcrumb.Item>
          </Breadcrumb>
          <div>
            <Search
              placeholder="Search"
              onChange={globalSearch}
              className="custom-search"
            />
          </div>
          <div>
            <Button type="primary" disabled onClick={showDrawer} style={{ marginRight: '8px' }}>
              <PlusCircleTwoTone />
              {' '}
              Add Template
            </Button>
            <Button type="primary" onClick={refreshData}>
              Refresh
            </Button>
          </div>
        </div>
        <div className="box">
          <div className="box__header">
            <h3 className="box-title">
              <Link to="/channels">
                <ArrowLeftOutlined className="arrow" />
              </Link>
              Email Template List
            </h3>
          </div>
          <div className="box__content p-0">
            <Table
              // scroll={{ y: 234 }}
              className="grid-table"
              columns={columns}
              dataSource={tableData}
            />
          </div>
        </div>
        <Drawer
          footer={false}
          title={title}
          width={1000}
          onClose={onClose}
          visible={visible}
          bodyStyle={{ paddingBottom: 80 }}
        >
          <Spin spinning={loadingBtn}>
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
            >
              <Form.Item
                label="Template Name"
                name="template_name"
                initialValue=""
                rules={[
                  {
                    required: true,
                    message: 'Please enter title name!',
                  },
                  // { min: 3, message: 'Title must be minimum 3 characters.' },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item style={{ textAlign: 'right', marginBottom: 0 }}>
                <Button icon={<PlusCircleTwoTone />} onClick={handleAddVariable} type="link">Add Variable</Button>
              </Form.Item>
              <Form.Item
                label="Template Content"
                name="email_content"
                initialValue=""
                rules={[
                  {
                    required: true,
                    message: 'Please enter the content!',
                  },
                  // { min: 3, message: 'Description must be minimum 3 characters.' },
                ]}
              >
                <HTMLEditor
                  ref={joditEditor}
                />
              </Form.Item>
              <Form.Item style={{ 'margin-bottom': 0 }}>
                <Button htmlType="submit" type="primary" disabled={loadingBtn}>
                  {loadingBtn ? 'Submitting...' : 'Submit'}
                </Button>
              </Form.Item>
            </Form>
          </Spin>
        </Drawer>
      </Spin>
      {ModalVisible
        ? (
          <div>
            <Modal width={1000} title="Template view" visible onOk={() => { setModalVisible(false); }} onCancel={() => { setModalVisible(false); }}>
              <p dangerouslySetInnerHTML={{ __html: Modalvalue }} />
            </Modal>
          </div>
        ) : ''}
    </div>
  );
};

export default EmailTemplate;
